import { Button, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { Check, X } from "lucide-react";
import { useState } from "react";
import { FinanceDialog } from "web_myplann/Dashboard/Components/FinanceDialog";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	GRASS_GREEN_MYPLANN,
	LIGHT_GREEN_MYPLANN,
} from "web_myplann/Utils/constants";

type ContactAgentDialogProps = {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

const DialogStep = {
	contact: "contact",
	success: "success",
} as const;

type DialogStepType = (typeof DialogStep)[keyof typeof DialogStep];

export const ContactAgentDialog = ({
	open,
	onClose,
	onConfirm,
}: ContactAgentDialogProps) => {
	const { t } = useResource();
	const theme = useTheme();
	const [step, setStep] = useState<DialogStepType>(DialogStep.contact);

	const handleClose = () => {
		setStep(DialogStep.contact);
		onClose();
	};

	const handleSuccessClose = () => {
		setStep(DialogStep.contact);
		onConfirm();
	};

	const handleConfirmClick = () => {
		setStep(DialogStep.success);
	};

	return (
		<>
			<FinanceDialog
				onClose={handleClose}
				open={open && step === DialogStep.contact}
			>
				<Stack py={2.4} px={1.6} gap={1.6}>
					<Stack
						direction="row"
						justifyContent="space-between"
						alignItems="center"
					>
						<Typography
							variant="deprecatedH3"
							color={theme.palette.deprecated.grey[700]}
						>
							{t(Resources.Dashboard.FinancialBalance.Modal1.title)}
						</Typography>
						<IconButton onClick={handleClose}>
							<X
								size={theme.iconSize.sm}
								color={theme.palette.deprecated.grey[700]}
							/>
						</IconButton>
					</Stack>
					<Typography
						variant="deprecatedBody1"
						color={theme.palette.deprecated.grey[700]}
					>
						{t(Resources.Dashboard.FinancialBalance.Modal1.description)}
					</Typography>
					<Button onClick={handleConfirmClick}>
						{t(Resources.Dashboard.FinancialBalance.Modal1.button)}
					</Button>
				</Stack>
			</FinanceDialog>
			<FinanceDialog
				onClose={handleSuccessClose}
				open={open && step === DialogStep.success}
				autoFadeOut
			>
				<Stack p={2.4} alignItems="center" gap={2.4}>
					<Stack
						width={48}
						height={48}
						borderRadius={theme.shape.pillRadius}
						bgcolor={LIGHT_GREEN_MYPLANN}
						alignItems="center"
						justifyContent="center"
					>
						<Check
							size={theme.iconSize.lg}
							color={GRASS_GREEN_MYPLANN}
							style={{ strokeWidth: 2 }}
						/>
					</Stack>
					<Stack gap={0.8} textAlign="center">
						<Typography
							variant="deprecatedH3"
							color={theme.palette.deprecated.grey[700]}
						>
							{t(Resources.Dashboard.FinancialBalance.Modal2.title)}
						</Typography>
						<Typography
							variant="deprecatedBody1"
							color={theme.palette.deprecated.grey[700]}
						>
							{t(Resources.Dashboard.FinancialBalance.Modal2.description)}
						</Typography>
					</Stack>
				</Stack>
			</FinanceDialog>
		</>
	);
};
